import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SettingsComponent } from './components/settings/settings.component';
import { OptionType } from '../core/enums/enums';
import { reducer } from './reducer/settings.reducer';
import { SettingsEffects } from './effects/settings.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(OptionType.Settings, reducer),
    EffectsModule.forFeature([SettingsEffects])
  ],
  declarations: [SettingsComponent],
  exports: [SettingsComponent]
})
export class SettingsModule {}
